var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomesvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.859,
    height: 18.931,
    viewBox: "0 0 16.859 18.931",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3102",
    "data-name": "Group 3102",
    transform: "translate(-9182.802 -11364.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M8073.4,11509.578v-11.758l7.836-5.673,7.523,5.673v11.758h-5.8v-7.205h-3.751v7.205Z",
    transform: "translate(1110.155 -127.162)",
    fill: "#f3f2f0",
    stroke: "#373334",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomesvg);
export default __webpack_public_path__ + "static/media/homesvg.87f1895a3276fb62e28a66c2577baa9f.svg";
export { ForwardRef as ReactComponent };